import { render, staticRenderFns } from "./Counters.vue?vue&type=template&id=19ca2455&scoped=true&"
import script from "./Counters.vue?vue&type=script&lang=js&"
export * from "./Counters.vue?vue&type=script&lang=js&"
import style0 from "./Counters.vue?vue&type=style&index=0&id=19ca2455&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ca2455",
  null
  
)

export default component.exports